import { Badge } from "./Badge";
import { formatRelative } from "../lib/format";
import { ApiRequestError } from "../types";
import type { RuntimeStatus } from "../types";

interface SystemPanelProps {
  status: RuntimeStatus | undefined;
  isLoading: boolean;
  error: unknown;
}

export function SystemPanel({ status, isLoading, error }: SystemPanelProps) {
  const ok = Boolean(status?.ok && status?.database?.ok);
  return (
    <article className="panel" aria-labelledby="systemPanelTitle">
      <div className="panel-header">
        <h2 id="systemPanelTitle">System</h2>
        <Badge tone={isLoading ? "" : ok ? "ok" : error ? "bad" : "muted"}>
          {isLoading ? "Loading" : error ? "Failed" : ok ? "OK" : "Down"}
        </Badge>
      </div>
      {error ? (
        <p className="panel-error">
          {error instanceof ApiRequestError
            ? `${error.endpoint} failed: ${error.message}`
            : `Request failed: ${(error as Error).message ?? "unknown error"}`}
        </p>
      ) : null}
      <dl className="facts">
        <dt>Service</dt>
        <dd className={status ? "" : "muted"}>{status?.service ?? "…"}</dd>
        <dt>Public URL</dt>
        <dd className={status ? "" : "muted"}>{status?.public_url ?? "…"}</dd>
        <dt>Database</dt>
        <dd className={status?.database?.ok ? "value-ok" : "value-bad"}>
          {status ? (status.database.ok ? "Reachable" : "Unavailable") : "…"}
        </dd>
        <dt>Checked</dt>
        <dd className="muted">
          {status ? formatRelative(status.database.checked_at) : "…"}
        </dd>
      </dl>
    </article>
  );
}
